export default {
  title: 'Marken',
  form: {
    name: {
      placeholder: 'Marke suchen...',
    },
  },
  fields: {
    id: '#',
    name: 'Name',
    address: 'Adresse',
    subdomain: 'Subdomain',
    shop_url: 'Shop-URL',
    companies: 'Unternehmen',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'Noch keine Marken',
  modals: {
    delete_franchise: {
      title: 'Sicher, dass du die Marke {{name}} löschen willst?',
    },
  },
  buttons: {
    new_franchise: '+ Marke hinzufügen',
    export_restaurants: 'Export Restaurants',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    view_dashboard_as_owner: 'Dashboard als Eigentümer anzeigen',
    open_shop: 'Shop öffnen',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    failed_to_delete_franchise: 'Marke konnte nicht gelöscht werden',
    franchise_got_deleted: 'Marke wurde gelöscht',
    failed_to_create_magic_link: 'Magischer Link konnte nicht erstellt werden',
    no_owner_to_log_in_as: 'Kein Restaurantinhaber zum Anmelden vorhanden',
  },
};
